<div class="w-100" style="min-height: 100vh;position: relative;overflow: hidden;">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <div class="bg-dark text-white text-center py-3 w-100" style="position: absolute;bottom: 0px;"> 
        Powered by TMDB. Developed by Jiatong Li. 
    </div>
</div>